'use strict';

import config from '../js/config';
import { runRequest } from '../utilities/makeRequest';
import { getLogger } from 'loglevel';
import _ from 'underscore';
import $ from 'jquery';

const log = getLogger('SamtecToolService');

let samtecToolService;
export class SamtecToolService {
  static getInstance() {
    if (!samtecToolService) {
      samtecToolService = new SamtecToolService();
    }
    return samtecToolService;
  }

  isPartInCatalog(partSeo, manufacturerSeo = 'samtec') {
    return runRequest({
      url: `${config.urls.samtecTool.isPartInCatalog}?partSeo=${partSeo}&manufacturerSeo=${manufacturerSeo}`,
      dataType: 'json',
    }).then((request) => {
      return request.response
    });
  }

  getSeriesInfo(series) {
    return Promise.all([this.getSeriesOption(series), this.getDocuments(series)])
      .then((response) => {
        return this.processData(response[0], response[1]);
      });
  }

  getManufacturerProductDetail(params) {
    return runRequest({
      url: `${config.pdpLite.getManufacturerProductDetailUrl}?` +  $.param(params),
      dataType: 'json'
    }).then((request) => {
      return request.response
    });
  }

  getNoncatalogProductDetail(params) {
    log.info(`${config.pdpLite.getNoncatalogProductDetailUrl}?` +  $.param(params));
    return runRequest({
      url: `${config.pdpLite.getNoncatalogProductDetailUrl}?` +  $.param(params),
      dataType: 'json'
    }).then((request) => {
      return request.response
    });
  }

  getProductSeriesOption(params) {
    log.info(`${config.pdpLite.getProductSeriesOptionUrl}?` +  $.param(params));
    return runRequest({
      url: `${config.pdpLite.getProductSeriesOptionUrl}?` +  $.param(params),
      dataType: 'json'
    }).then((request) => {
      return request.response
    });
  }

  getPromotionalItems() {
    return runRequest({
      url: `${config.pdpLite.getPromotionalItemsUrl}`,
      dataType: 'json'
    }).then((request) => {
      return request.response
    });
  }

  getPromotionalItem(id) {
    return runRequest({
      url: `${config.pdpLite.getPromotionalItemUrl}?` +  $.param({promotionalItem: id}),
      dataType: 'html'
    }).then((request) => {
      return request.response
    });
  }

  getSeriesInfo(series) {
    return Promise.all([this.getSeriesOption(series), this.getDocuments(series)])
      .then((response) => {
        return this.processData(response[0], response[1]);
      });
  }

  getVideosArticlesInfo(queryParams) {
    return Promise.all([this.getVideosArticles(queryParams)])
      .then((response) => {
        return response;
      });
  }

  processData(seriesInfo, documents) {
    const spec = _.find(documents, (item) => {
      return item.SeriesDocumentType1Description === config.pdpLite.productSpec;
    });

    const dataSheet = _.find(documents, (item) => {
      return (item.SeriesDocumentType1Description === config.pdpLite.catalogPage) && (item.LanguageISO === config.pdpLite.langEng);
    });

    const rohs = _.find(seriesInfo.features, (item) => {
      return (item.description === config.pdpLite.rohsCompliant);
    });

    let result = {
      descripton: seriesInfo.seriesOverview,
      imageUrl: `${config.pdpLite.imageUrl}${seriesInfo.thumbnailImagePath}`,
      specUrl: `${config.pdpLite.docUrl}/${spec.Path}`,
      datasheetUrl: `${config.pdpLite.docUrl}/${dataSheet.Path}`,
      breadcrumbPath: seriesInfo.breadcrumbPath,
      features: seriesInfo.features,
      rohs : !!rohs
    };
    return result;
  }

  getSeriesOption(seriesName) {
    return this.samtecApiRequest(`${config.pdpLite.dataApiUrl}/seriesmasteroption/${seriesName}`, {});
  }

  getDocuments(seriesName) {
    return this.samtecApiRequest(`${config.pdpLite.docApiUrl}/documents/${seriesName}`, {});
  }

  getVideosArticles(queryParams) {
    return this.samtecApiRequest(`${config.pdpLite.pdpLiteArticlesVideos}`, queryParams);
  }

  samtecApiRequest(url, params) {
    const $ = jQuery;
    return runRequest({
      url: url + "?" + $.param(params),
      type: "GET",
    }).then((request) => {
      return request.response;
    });
  }
}




// WEBPACK FOOTER //
// ./assets/services/SamtecToolService.js